import useGetMyPermissionsFromCache from '~/features/user/hooks/useGetMyPermissionsFromCache'
import { EAccessLevel, EInternalAdminCapability } from '~/features/user/models'
import useGetAuthSessionQuery from '~/hooks/useGetAuthSessionQuery'
import { ECognitoGroups } from '~/models/auth'

// Mirrors useCanLoginAs's shape: `admin` always qualifies; `adminLimited`
// only with the specific capability grant (grantsAll or an explicit edit
// grant for manageAdminUsers).
const useCanManageAdminUsers = () => {
  const { data: authSession } = useGetAuthSessionQuery()
  const { data: permissions, isPending: isPermissionsPending } =
    useGetMyPermissionsFromCache()
  const groups = authSession?.groups ?? []
  const hasAdminRole = groups.includes(ECognitoGroups.admin)

  const hasAdminLimitedGrant =
    groups.includes(ECognitoGroups.adminLimited) &&
    (permissions?.internalAdmin?.grantsAll ||
      permissions?.internalAdmin?.capabilities?.[
        EInternalAdminCapability.manageAdminUsers
      ] === EAccessLevel.edit)

  return {
    canManageAdminUsers: hasAdminRole || hasAdminLimitedGrant,
    // Only an adminLimited grant depends on the permissions fetch — a full
    // admin is never gated by it. A consumer that redirects on `false` (the
    // page guard) must check this first: redirecting while still loading
    // would bounce a legitimately-entitled adminLimited user away before
    // their grant has even arrived, on every hard load or deep link.
    isLoading: !hasAdminRole && isPermissionsPending,
  }
}

export default useCanManageAdminUsers
